import { useState } from "react";
import { Link } from "react-router-dom";
import { NEWS } from "@/mocks/news";
import NewsCard from "@/components/feature/NewsCard";
import { formatViews } from "@/utils/format";

const FAQS = [
  {
    q: "娱乐爆料的资讯来源是什么？多久更新一次？",
    a: "我们整合公开报道、行业信源与编辑部亲赴现场的直击，坚持每日更新。所有内容都经过人工核实与交叉求证后才发布，力求第一时间、也第一真实。",
  },
  {
    q: "所谓的「独家爆料」可信吗？",
    a: "凡标注「独家」的内容，均为编辑团队通过自身信源获取并逐一核实的首发消息。我们会在正文中尽量说明信息来源与核实过程，并对存疑部分明确标注，绝不为了抢时效而放弃真实。",
  },
  {
    q: "图文内容的版权归谁所有？",
    a: "本站部分图文由编辑部原创，部分转载内容会标注原作者与出处。任何媒体或个人如需转载，请先通过页面底部的邮箱与我们取得联系并获得授权。",
  },
  {
    q: "我可以投稿线索或提供爆料吗？",
    a: "当然欢迎！如果你掌握第一手现场素材或行业线索，可通过页脚邮箱联系我们。我们会保护爆料人隐私，在核实无误后安排报道。",
  },
  {
    q: "网站会上传我的个人信息吗？",
    a: "不会。订阅邮箱仅用于接收每日爆料推送，我们严格遵循隐私与数据安全规范，不会向第三方出售或分享你的任何信息。",
  },
];

export default function HomePage() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const featured = NEWS[0];
  const hotList = [...NEWS].sort((a, b) => b.views - a.views).slice(0, 5);
  const exclusive = NEWS.filter((n) => n.exclusive);
  const dramaNews = NEWS.filter((n) => n.categorySlug === "drama").slice(0, 3);
  const musicNews = NEWS.filter((n) => n.categorySlug === "music").slice(0, 3);
  const varietyNews = NEWS.filter((n) => n.categorySlug === "variety").slice(0, 2);
  const rest = NEWS.filter((n) => n.id !== "n01").slice(0, 6);

  return (
    <div>
      {/* ============ HERO ============ */}
      <section className="relative overflow-hidden bg-foreground-950">
        <div className="absolute inset-0">
          <img
            src={featured.cover}
            alt={featured.alt}
            className="h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/60 to-foreground-950/20"></div>
        </div>
        <div className="relative mx-auto flex min-h-[520px] max-w-7xl flex-col justify-end px-4 pb-12 pt-24 md:min-h-[600px] md:px-6 md:pb-16">
          <div className="flex flex-wrap items-center gap-2">
            <span className="rounded bg-primary-500 px-2.5 py-1 text-xs font-bold text-background-50">
              {featured.tag}
            </span>
            <span className="rounded bg-accent-500 px-2.5 py-1 text-xs font-bold text-background-50">
              今日头条
            </span>
          </div>
          <h1 className="mt-4 max-w-4xl text-2xl font-black leading-snug text-background-50 md:text-4xl md:leading-snug">
            <Link to={`/news/${featured.slug}`} className="hover:opacity-90">
              {featured.title}
            </Link>
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            {featured.summary}
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-4 text-xs text-background-300">
            <span className="inline-flex items-center gap-2">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-accent-500 text-background-50">
                <i className="ri-quill-pen-fill text-sm"></i>
              </span>
              作者：{featured.author}
            </span>
            <span className="inline-flex items-center gap-1"><i className="ri-calendar-line"></i>{featured.date}</span>
            <span className="inline-flex items-center gap-1"><i className="ri-eye-line"></i>{formatViews(featured.views)}</span>
          </div>
          <div className="mt-7 flex flex-wrap items-center gap-3">
            <Link
              to={`/news/${featured.slug}`}
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              阅读全文 <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/category/exclusive"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-200/50 px-5 py-3 text-sm font-semibold text-background-100 transition-colors hover:bg-background-50/10"
            >
              更多独家
            </Link>
          </div>
        </div>
      </section>

      {/* ============ 热门资讯两栏 ============ */}
      <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          {/* 左：独家首发 */}
          <div className="lg:col-span-2">
            <div className="mb-5 flex items-end justify-between border-b border-background-200 pb-3">
              <div>
                <span className="text-xs font-bold uppercase tracking-widest text-primary-600">First-hand</span>
                <h2 className="mt-1 text-xl font-black text-foreground-950 md:text-2xl">独家首发 · 第一手资讯</h2>
              </div>
              <Link to="/category/exclusive" className="whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700">
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="flex flex-col gap-4">
              {exclusive.map((item) => (
                <NewsCard key={item.id} item={item} horizontal />
              ))}
            </div>
          </div>

          {/* 右：热搜榜 */}
          <aside aria-label="娱乐热搜榜">
            <div className="rounded-lg border border-background-200 bg-background-100 p-5">
              <div className="mb-4 flex items-center justify-between">
                <h2 className="flex items-center gap-2 text-lg font-black text-foreground-950">
                  <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                    <i className="ri-fire-fill text-base"></i>
                  </span>
                  热搜榜
                </h2>
                <span className="text-xs text-foreground-400">实时更新</span>
              </div>
              <ol className="space-y-1">
                {hotList.map((item, idx) => (
                  <li key={item.id}>
                    <Link
                      to={`/news/${item.slug}`}
                      className="group flex items-start gap-3 rounded-md px-2 py-2.5 transition-colors hover:bg-background-50"
                    >
                      <span
                        className={`mt-0.5 w-6 shrink-0 text-center font-display text-lg font-bold ${
                          idx < 3 ? "text-primary-600" : "text-foreground-300"
                        }`}
                      >
                        {idx + 1}
                      </span>
                      <span className="flex-1">
                        <span className="line-clamp-2 text-sm font-semibold leading-snug text-foreground-800 group-hover:text-primary-700">
                          {item.title}
                        </span>
                        <span className="mt-1 flex items-center gap-2 text-xs text-foreground-400">
                          <i className="ri-fire-line"></i>{formatViews(item.views)}热度
                        </span>
                      </span>
                      {idx < 3 && <span className="mt-1 text-primary-500"><i className="ri-arrow-up-s-line text-base"></i></span>}
                    </Link>
                  </li>
                ))}
              </ol>
              <div className="mt-4 rounded-md bg-accent-500 p-4 text-background-50">
                <p className="text-sm font-bold">想知道娱乐圈今天又发生了什么？</p>
                <p className="mt-1 text-xs leading-relaxed text-background-100">
                  订阅娱乐爆料，每日第一手资讯准时送达。
                </p>
              </div>
            </div>
          </aside>
        </div>
      </section>

      {/* ============ 分类资讯 ============ */}
      <section className="border-y border-background-200 bg-background-100">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-3">
          <div>
            <div className="mb-5 flex items-end justify-between border-b border-background-200 pb-3">
              <h2 className="text-xl font-black text-foreground-950 md:text-2xl">热剧追踪</h2>
              <Link to="/category/drama" className="whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700">
                更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="flex flex-col gap-4">
              {dramaNews.map((item) => <NewsCard key={item.id} item={item} horizontal />)}
            </div>
          </div>
          <div>
            <div className="mb-5 flex items-end justify-between border-b border-background-200 pb-3">
              <h2 className="text-xl font-black text-foreground-950 md:text-2xl">音乐现场</h2>
              <Link to="/category/music" className="whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700">
                更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="flex flex-col gap-4">
              {musicNews.map((item) => <NewsCard key={item.id} item={item} horizontal />)}
            </div>
          </div>
          <div>
            <div className="mb-5 flex items-end justify-between border-b border-background-200 pb-3">
              <h2 className="text-xl font-black text-foreground-950 md:text-2xl">综艺圈</h2>
              <Link to="/category/variety" className="whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700">
                更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="flex flex-col gap-4">
              {varietyNews.map((item) => <NewsCard key={item.id} item={item} horizontal />)}
            </div>
          </div>
        </div>
      </section>

      {/* ============ 资讯卡片流 ============ */}
      <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="mb-5 flex items-end justify-between border-b border-background-200 pb-3">
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-primary-600">Updates</span>
            <h2 className="mt-1 text-xl font-black text-foreground-950 md:text-2xl">最新娱乐资讯</h2>
          </div>
          <Link to="/category/all" className="whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700">
            全部资讯 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {rest.map((item) => <NewsCard key={item.id} item={item} />)}
        </div>
      </section>

      {/* ============ 品牌介绍 ============ */}
      <section className="relative overflow-hidden bg-primary-600">
        <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 py-14 md:px-6 lg:grid-cols-2">
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-background-100/80">About 娱乐爆料</span>
            <h2 className="mt-3 text-2xl font-black leading-snug text-background-50 md:text-3xl">
              带你走在吃瓜最前线的一手资讯平台
            </h2>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-100 md:text-base">
              娱乐爆料专注娱乐行业第一手资讯，以「独家首发」为核心，坚持现场直击、交叉核实与真实表达。无论是明星动态、热剧片场、音乐现场还是综艺幕后，我们都愿意多跑一步、多问一句，把最鲜活的内容抢先带给你。
            </p>
            <div className="mt-7 flex flex-wrap gap-3">
              <Link to="/about" className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-5 py-3 text-sm font-bold text-primary-700 transition-colors hover:bg-background-100">
                了解更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {[
              { num: "365", label: "全年无休更新", icon: "ri-calendar-check-line" },
              { num: "100%", label: "人工交叉核实", icon: "ri-shield-check-line" },
              { num: "24h", label: "现场直击响应", icon: "ri-flashlight-line" },
              { num: "8+", label: "专业编辑团队", icon: "ri-group-line" },
            ].map((s) => (
              <div key={s.label} className="rounded-lg bg-background-50/10 p-5 backdrop-blur-sm">
                <i className={`${s.icon} text-2xl text-accent-300`}></i>
                <p className="mt-3 font-display text-3xl font-bold text-background-50">{s.num}</p>
                <p className="mt-1 text-sm text-background-100">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ FAQ ============ */}
      <section className="mx-auto max-w-4xl px-4 py-12 md:px-6 md:py-16">
        <div className="text-center">
          <span className="text-xs font-bold uppercase tracking-widest text-primary-600">FAQ</span>
          <h2 className="mt-2 text-2xl font-black text-foreground-950 md:text-3xl">常见问题</h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600">
            关于娱乐爆料的资讯来源、独家内容与版权，这里为你一一解答。
          </p>
        </div>
        <div className="mt-8 space-y-3">
          {FAQS.map((f, i) => (
            <div key={f.q} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                aria-expanded={openIndex === i}
              >
                <span className="text-sm font-bold text-foreground-950 md:text-base">{f.q}</span>
                <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-700 transition-transform ${openIndex === i ? "rotate-180 bg-primary-100 text-primary-700" : ""}`}>
                  <i className="ri-add-line"></i>
                </span>
              </button>
              <div className={`grid transition-all duration-300 ${openIndex === i ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
                <div className="overflow-hidden">
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}